import React, { useState, useEffect } from 'react';
import {useStock} from '../../contexts/stockContexts'; 
import Shopify from '../../assets/images/icons8-shopify-100.png';
import Shopifyna from '../../assets/images/icons8-shopify-100_na.png';
export default function ShopifyHeader() {
  const [orderCount, setOrderCount] = useState(0);
  const [trend, setTrend] = useState(15.3);
  const [chartData, setChartData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const {instock,stockItems,ordergraphsdata,salesdata,isshopifyconnected} = useStock();
  

  // Generate random chart data
  

  return (
       isshopifyconnected ?  
       <>
         <img src={Shopify} alt="Logo"  style={{width:'58px'}}/>
       </>
       :(<img src={Shopifyna} alt="Logo"  style={{width:'46px'}}/>)
  );
}


export function Shopifyproductsfetch() {
  const [orderCount, setOrderCount] = useState(0);
  const [trend, setTrend] = useState(15.3);
  const [chartData, setChartData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const {instock,stockItems,ordergraphsdata,salesdata,isshopifyconnected,getShopifyProducts,shopifystocks} = useStock();
  

  // Generate random chart data
  

  return (
       isshopifyconnected ?  
       <>
         <button className='btn btn-default flex' onClick={() => getShopifyProducts()}><img src={Shopify} alt="Logo"  style={{width:'40px'}}/><span>Fetch Stock</span>{shopifystocks.loading ? <span> ....</span>:<></>}</button>
       </>
       :(<></>)
  );
}


export function Shopifyordersfetch() {
  const [orderCount, setOrderCount] = useState(0);
  const [trend, setTrend] = useState(15.3);
  const [chartData, setChartData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const {instock,stockItems,ordergraphsdata,salesdata,isshopifyconnected,getShopifyProducts,shopifystocks,getShopifyorders} = useStock();
  

  // Generate random chart data
  return (
       isshopifyconnected ?  
       <>
         <button className='btn btn-default flex' onClick={() => getShopifyorders()}><img src={Shopify} alt="Logo"  style={{width:'40px'}}/><span>Fetch Orders</span>{shopifystocks.ordersloading ? <span> ....</span>:<></>}</button>
       </>
       :(<></>)
  );
}


export function Shopifywarehousesfetch() {
  const [orderCount, setOrderCount] = useState(0);
  const [trend, setTrend] = useState(15.3);
  const [chartData, setChartData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const {instock,stockItems,ordergraphsdata,salesdata,isshopifyconnected,getShopifyProducts,shopifystocks,getShopifyorders,getShopifyLocationsviaAdminapi,warehouses} = useStock();
  

  // Generate random chart data
  return (
       isshopifyconnected ?  
       <>
         <button className='btn btn-default flex' onClick={() => getShopifyLocationsviaAdminapi()}><img src={Shopify} alt="Logo"  style={{width:'40px'}}/><span>Fetch Warehouses</span>{warehouses.loading ? <span> ....</span>:<></>}</button>
       </>
       :(<></>)
  );
}


export function OutofStock() {
  const [orderCount, setOrderCount] = useState(0);
  const [trend, setTrend] = useState(15.3);
  const [chartData, setChartData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const {instock,stockItems,ordergraphsdata,salesdata,isshopifyconnected,getShopifyProducts,shopifystocks,getShopifyorders} = useStock();
  

  // Generate random chart data
  return (
       isshopifyconnected ?  
       <>
         <button className='btn btn-default flex' onClick={() => getShopifyorders()}><img src={Shopify} alt="Logo"  style={{width:'40px'}}/><span>Fetch Orders</span>{shopifystocks.ordersloading ? <span> ....</span>:<></>}</button>
       </>
       :(<></>)
  );
}

export function Shopifyactualproductsfetch() {
  const [orderCount, setOrderCount] = useState(0);
  const [trend, setTrend] = useState(15.3);
  const [chartData, setChartData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const {instock,stockItems,ordergraphsdata,salesdata,isshopifyconnected,getShopifyProducts,shopifystocks,getShopifyactualProducts} = useStock();
  

  // Generate random chart data
  

  return (
       isshopifyconnected ?  
       <>
         <button className='btn btn-default flex' onClick={() => getShopifyactualProducts()}><img src={Shopify} alt="Logo"  style={{width:'40px'}}/><span>Fetch Products</span>{shopifystocks.loading ? <span> ....</span>:<></>}</button>
       </>
       :(<></>)
  );
}